/* Keep custom content navigation in the active Maltese storefront. */
(() => {
  if (window.dpetLocaleNavigation) return;
  const isMaltese = /^\/mt(?:\/|$)/.test(location.pathname);
  const path = (pathname = location.pathname) => pathname.replace(/^\/mt(?=\/|$)/, '') || '/';
  const href = (value) => {
    if (!isMaltese || typeof value !== 'string' || !value || value.startsWith('#')) return value;
    let url;
    try { url = new URL(value, location.href); } catch (_) { return value; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return value;
    // Never rewrite app, account, cart, checkout, discount or other service routes.
    if (!/^(?:\/$|\/(?:collections|products|pages|blogs|policies|search)(?:\/|$))/.test(url.pathname)) return value;
    return '/mt' + url.pathname + url.search + url.hash;
  };
  const maltese = {
    "Dog essentials": "Essenzjali għall-klieb",
    "Pawfit GPS trackers": "Traċċaturi GPS Pawfit",
    "Food & nutrition": "Ikel u nutrizzjoni",
    "Treats & rewards": "Snacks u premjijiet",
    "Bowls, feeders & water": "Skutelli u tagħmir għall-ikel u l-ilma",
    "Toys & enrichment": "Ġugarelli u stimulazzjoni",
    "Collars, harnesses & leads": "Kullari, arnessi u ċineg",
    "Grooming & wellbeing": "Kura u benesseri",
    "Training & toilet care": "Taħriġ u kura għall-bżonnijiet",
    "Beds & rest": "Sodod u mistrieħ",
    "Kennels & playpens": "Djar għall-klieb u spazji tal-logħob",
    "Summer & cooling essentials": "Essenzjali għas-sajf u biex jibqgħu friski",
    "Calming support": "Għajnuna biex jikkalmaw",
    "Cat essentials": "Essenzjali għall-qtates",
    "Collars & safety": "Kullari u sigurtà",
    "Toys & scratching": "Ġugarelli u tagħmir għall-grif",
    "Litter & home care": "Mifrex u kura tad-dar",
    "Beds & cosy spaces": "Sodod u spazji komdi",
    "Calming & support": "Serħan u għajnuna",
    "Carriers & travel": "Basktijiet tat-trasport u vjaġġar",
    "Explore bird essentials": "Skopri l-essenzjali għall-għasafar",
    "ZuPreem": "ZuPreem",
    "Lafeber": "Lafeber",
    "TOP’s": "TOP’s",
    "PUUR": "PUUR",
    "CuniPic": "CuniPic",
    "Cages & aviaries": "Gaġeġ u guvi",
    "Feeders & drinkers": "Tagħmir għall-ikel u l-ilma",
    "Perches & natural enrichment": "Perċijiet u stimulazzjoni naturali",
    "Health & supplements": "Saħħa u supplimenti",
    "Care & hygiene": "Kura u iġjene",
    "Fishkeeping essentials": "Essenzjali għall-kura tal-ħut",
    "Complete Askoll aquariums": "Akkwarji kompluti Askoll",
    "Fish food & nutrition": "Ikel u nutrizzjoni għall-ħut",
    "Turtle & terrapin food": "Ikel għall-fkieren tal-ilma",
    "Filtration & water quality": "Filtrazzjoni u kwalità tal-ilma",
    "Water care & filter media": "Kura tal-ilma u materjal għall-filtri",
    "Cleaning & maintenance": "Tindif u manutenzjoni",
    "Décor & aquascaping": "Dekorazzjoni u tqassim tal-akkwarju",
    "LED lighting": "Dawl LED",
    "Plant care & CO₂": "Kura tal-pjanti u CO₂",
    "Water testing": "Testijiet tal-ilma",
    "Fish treatments": "Trattamenti għall-ħut",
    "Explore small-pet essentials": "Skopri l-essenzjali għall-annimali żgħar",
    "Food & daily nutrition": "Ikel u nutrizzjoni ta’ kuljum",
    "Hay & fibre": "Ħuxlief u fibra",
    "Bedding & litter": "Materjal għall-qiegħ u mifrex",
    "Bowls & bottles": "Skutelli u fliexken",
    "Cages & habitats": "Gaġeġ u ħabitats",
    "Play & enrichment": "Logħob u stimulazzjoni",
    "Treats & chews": "Snacks u prodotti għall-gdim",
    "Health & hygiene": "Saħħa u iġjene",
    "Explore reptile essentials": "Skopri l-essenzjali għar-rettili",
    "Habitat accessories": "Aċċessorji għall-ħabitat",
    "Turtle food & care": "Ikel u kura għall-fkieren",
    "Heating & lighting": "Tisħin u dawl",
    "Terrariums & habitats": "Terrarji u ħabitats",
    "Care & habitat": "Kura u ħabitat",
    "Explore garden essentials": "Skopri l-essenzjali għall-ġnien",
    "Soil, compost & plant care": "Ħamrija, kompost u kura tal-pjanti",
    "Watering & irrigation": "Tisqija u irrigazzjoni",
    "Pots, planters & saucers": "Qsari u platti għall-qsari",
    "Garden tools": "Għodod għall-ġnien",
    "Garden & pest control": "Ġnien u kontroll tal-pesti",
    "Summer garden care": "Kura tal-ġnien fis-sajf",
    "Growing & garden care": "Tkabbir u kura tal-ġnien",
    "All dPet.mt essentials": "L-essenzjali kollha ta’ dPet.mt",
    "Current offers": "Offerti attwali",
    "dPet Offers": "Offerti ta’ dPet.mt",
    "Hot arrivals": "L-aħħar prodotti",
    "Featured picks": "Prodotti magħżula",
    "New at dPet.mt": "Ġdid fuq dPet.mt",
    "Summer essentials": "Essenzjali għas-sajf",
    "Autumn & winter essentials": "Essenzjali għall-ħarifa u x-xitwa",
    "Halloween collection": "Kollezzjoni ta’ Halloween",
    "Digital gift cards": "Gift cards diġitali",
    "Open filters to refine products": "Iftaħ il-filtri biex tirfina l-prodotti",
    "Filter products": "Iffiltra l-prodotti",
    "Taxes included.": "Taxxi inklużi.",
    "Shipping": "Il-kunsinna",
    "calculated at checkout.": "tiġi kkalkulata waqt il-checkout.",
    "Home": "Paġna ewlenija",
    "Products": "Prodotti",
    "Policies": "Politiki",
    "Breadcrumbs": "Mogħdija tan-navigazzjoni",
    "Little extras. Happier pets.": "Ftit affarijiet żejda. Annimali aktar kuntenti.",
    "Mix your pets’ favourites, unlock automatic savings and enjoy thoughtful service across Malta and Gozo.": "Għaqqad il-prodotti favoriti tal-annimali tiegħek, ibbenefika minn skontijiet awtomatiċi u gawdi servizz b’attenzjoni f’Malta u Għawdex.",
    "dPet.mt shopping benefits": "Vantaġġi tax-xiri minn dPet.mt",
    "Free next working day delivery": "Kunsinna bla ħlas fil-jum tax-xogħol li jmiss",
    "Across Malta and Gozo on orders of €45 or more.": "F’Malta u Għawdex għal ordnijiet ta’ €45 jew aktar.",
    "3 points for every €1": "3 punti għal kull €1",
    "100 dRewards points gives you €1 off a future purchase.": "100 punt dRewards jagħtuk €1 skont fuq xiri fil-futur.",
    "A small surprise inside": "Sorpriża żgħira fil-pakkett",
    "Expect a little thank-you from us in your box.": "Stenna rigal żgħir ta’ ringrazzjament mingħandna fil-kaxxa tiegħek.",
    "Automatic launch savings": "Skontijiet awtomatiċi tat-tnedija",
    "No code needed. Mix and match qualifying products within each brand.": "M’hemmx bżonn kodiċi. Għaqqad prodotti eliġibbli tal-istess marka.",
    "Made for Malta’s pet families": "Għall-familji f’Malta li għandhom annimali domestiċi",
    "Savings appear automatically at checkout when the quantity is met. Offers are subject to availability while the launch promotion is active.": "L-iskontijiet jidhru awtomatikament waqt il-checkout meta tintlaħaq il-kwantità meħtieġa. L-offerti jiddependu mid-disponibbiltà sakemm il-promozzjoni tat-tnedija tkun attiva.",
    "Buy {qty} · save {pct}%": "Ixtri {qty} · iffranka {pct}%",
    "{brand} launch bundle": "Pakkett promozzjonali {brand} għat-tnedija",
    "Add any {qty} qualifying {brand} products and get {pct}% off automatically.": "Żid kwalunkwe {qty} prodotti eliġibbli ta’ {brand} u ħu skont ta’ {pct}% awtomatikament.",
    "Shop {brand}": "Ixtri {brand}",
    "Loading customer favourites…": "Qed jitgħabbew il-prodotti favoriti tal-klijenti…",
    "Products are being prepared for this offer.": "Il-prodotti għal din l-offerta qed jitħejjew.",
    "Explore the full qualifying range below.": "Skopri l-firxa kollha eliġibbli hawn taħt."
  };
  const translate = (source, values = {}) => {
    const text = isMaltese ? (maltese[source] || source) : source;
    return text.replace(/\{(\w+)\}/g, (token, key) => Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : token);
  };
  window.dpetLocaleNavigation = { path, href, isMaltese, translate };
  if (!isMaltese) return;
  const localizeLink = (link) => {
    // Language selectors must remain able to return to English.
    if (link.hasAttribute('hreflang') || link.hasAttribute('download') || link.closest('localization-form, .localization-form, form[action*="/localization"], [data-localization], [data-locale-selector], [class*="language-selector"], [class*="localization"]')) return;
    const current = link.getAttribute('href');
    const next = href(current);
    if (next !== current) link.setAttribute('href', next);
  };
  const localizeLinks = (root) => {
    if (root instanceof Element && root.matches('a[href]')) localizeLink(root);
    root.querySelectorAll('a[href]').forEach(localizeLink);
  };
  const start = () => {
    localizeLinks(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node instanceof Element) localizeLinks(node);
      }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Shared dPet enhancements. Content stays visible if JavaScript or motion is unavailable. */
(() => {
  const style = document.createElement('style');
  style.textContent = `
    body:not(:has(#MainContent > [id*="__dpet_about"])) .shopify-section-group-header-group:has([class*="ai-image-hero-"]){display:none!important}
    @media(prefers-reduced-motion:no-preference){
      .dpet-reveal-ready{opacity:0;transform:translateY(18px);transition:opacity .55s ease,transform .55s cubic-bezier(.2,.7,.2,1)}
      .dpet-reveal-ready.dpet-reveal-visible{opacity:1;transform:none}
    }
    .dpet-content-protection{-webkit-touch-callout:none}
    .dpet-content-protection body{user-select:none}
    /* Keep both Smile launcher versions readable and clear of WhatsApp. */
    html :is(#smile-ui-lite-launcher-frame-container,.smile-launcher-frame-container){position:fixed!important;left:12px!important;right:auto!important;top:auto!important;bottom:var(--dpet-rewards-bottom,max(16px,calc(env(safe-area-inset-bottom,0px) + 12px)))!important;width:156px!important;height:56px!important;overflow:visible!important;transform:none!important;filter:drop-shadow(0 6px 16px #153f2c24);z-index:2147483640!important;background:#e58a2b!important;border:0!important;border-radius:28px!important;box-sizing:border-box!important;transition:bottom .22s ease,opacity .2s ease!important}
    html .smile-launcher-frame-container.smile-launcher-closed{visibility:visible!important}
    html :is(#smile-lite-launcher-frame,.smile-launcher-frame){position:absolute!important;inset:0!important;width:100%!important;height:100%!important;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;transform:none!important;cursor:pointer;background:#e58a2b!important;border:0!important;border-radius:28px!important;filter:none!important}
    @media(prefers-reduced-motion:reduce){html :is(#smile-ui-lite-launcher-frame-container,.smile-launcher-frame-container){transition:none!important}}
shopify-chat::part(activator){background:#e58a2b!important;color:#123d2a!important;border:2px solid #123d2a!important;box-shadow:0 8px 22px #123d2a2e!important;opacity:1!important}
shopify-chat[open]::part(dialog){max-height:calc(100dvh - 100px)!important}
    .dpet-content-protection img{-webkit-touch-callout:none;-webkit-user-drag:none;user-select:none}
    .dpet-content-protection :is(input,textarea,select,[contenteditable],[role=textbox]){-webkit-touch-callout:default;user-select:text}
    .dpet-socials{display:flex;flex-direction:column;align-items:center;gap:10px;padding:22px 20px 18px;color:#123d2a;text-align:center;background:linear-gradient(180deg,#fcf8f1 0%,#fff 100%)}
    .dpet-socials__label{margin:0;font-weight:700;letter-spacing:.04em;font-size:14px;text-transform:none}
    .dpet-socials__icons{display:flex;align-items:center;justify-content:center;gap:12px;flex-wrap:wrap}
    .dpet-socials__icon{width:42px;height:42px;border-radius:50%;display:grid;place-items:center;background:#123d2a;color:#fff;border:2px solid #e58a2b;box-shadow:0 6px 14px #123d2a1c;font-size:18px;transition:transform .25s ease,box-shadow .25s ease}
    @media(hover:hover) and (pointer:fine){.dpet-socials__icon:hover{transform:translateY(-3px) rotate(-4deg);box-shadow:0 10px 20px #123d2a26}}
    @media(prefers-reduced-motion:reduce){.dpet-socials__icon{transition:none}}
  `;
  document.head.append(style);
  // Carousel motion is owned by dpet-arrivals in product-list.liquid.

/* dPet.mt product grid, expanded menus and clear filter control — 2026-10 */
(() => {
  const STYLE_ID = 'dpet-grid-menu-filter-v1';
  const css = [
    "product-card{height:100%;}",
    "product-card .product-card__content{height:100%;}",
    "product-card .card-gallery{--gallery-aspect-ratio:1!important;aspect-ratio:1/1!important;position:relative!important;overflow:hidden!important;isolation:isolate;background:#fff!important;border:1px solid rgba(18,61,42,.10)!important;border-radius:clamp(16px,2vw,24px)!important;box-shadow:0 10px 28px rgba(18,61,42,.07);transition:transform .35s cubic-bezier(.2,.8,.2,1),box-shadow .35s ease,border-color .35s ease;}",
    "product-card .card-gallery>a.contents{display:block!important;width:100%!important;height:100%!important;position:relative!important;}",
    "product-card .card-gallery .product-media-container,product-card .card-gallery .product-media{width:100%!important;height:100%!important;min-height:0!important;aspect-ratio:1/1!important;}",
    "product-card .card-gallery .product-media-container{position:absolute!important;inset:0!important;background:#fff!important;}",
    "product-card .card-gallery .product-media{position:relative!important;inset:auto!important;}",
    "product-card .card-gallery img{display:block!important;width:100%!important;height:100%!important;max-width:none!important;object-fit:contain!important;object-position:center!important;padding:clamp(12px,1.65vw,24px)!important;box-sizing:border-box!important;transform:scale(.96);transition:transform .45s cubic-bezier(.2,.8,.2,1),filter .4s ease;}",
    "product-card .card-gallery:before{content:'';position:absolute;z-index:4;top:12px;right:12px;display:block;width:36px;height:36px;border-radius:50%;background:#e58a2b url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cellipse cx='5.8' cy='9' rx='2.3' ry='3' transform='rotate(-25 5.8 9)'/%3E%3Cellipse cx='10' cy='5.7' rx='2.2' ry='2.9'/%3E%3Cellipse cx='15.5' cy='6' rx='2.2' ry='2.9' transform='rotate(12 15.5 6)'/%3E%3Cellipse cx='19' cy='10.3' rx='2.1' ry='2.8' transform='rotate(28 19 10.3)'/%3E%3Cpath d='M6.5 17c0-2 1.3-3 2.5-4.3 1.5-1.7 3.8-2 5.4-.3 1.4 1.4 3.2 2.6 3.2 4.8 0 3.8-3.5 3.4-5.5 2.7-2.3.8-5.6 1-5.6-2.9z'/%3E%3C/svg%3E\") center/22px 22px no-repeat;box-shadow:0 3px 10px #123d2a16;opacity:0;transform:translate(5px,-5px) rotate(12deg) scale(.8);transition:opacity .3s ease,transform .38s cubic-bezier(.2,.8,.2,1);pointer-events:none;}product-card:has(.product-badges__badge) .card-gallery:before{display:none;}",
    "product-card .card-gallery:after{content:'';position:absolute;z-index:4;left:16px;bottom:15px;width:58px;height:28px;background:linear-gradient(13deg,transparent 43%,rgba(18,61,42,.68) 45%,rgba(18,61,42,.68) 49%,transparent 51%) 0 0/100% 33%,linear-gradient(0deg,transparent 43%,rgba(18,61,42,.68) 45%,rgba(18,61,42,.68) 49%,transparent 51%) 0 50%/100% 33%,linear-gradient(-13deg,transparent 43%,rgba(18,61,42,.68) 45%,rgba(18,61,42,.68) 49%,transparent 51%) 0 100%/100% 33%;background-repeat:no-repeat;opacity:0;transform:translateX(-10px) scale(.8);transition:opacity .3s ease .04s,transform .38s cubic-bezier(.2,.8,.2,1) .04s;pointer-events:none;}",
    "@media (hover:hover) and (min-width:750px){product-card:hover .card-gallery{transform:translateY(-5px);border-color:rgba(239,107,46,.38)!important;box-shadow:0 18px 38px rgba(18,61,42,.13);}product-card:hover .card-gallery img{transform:scale(1.025) rotate(.35deg);filter:saturate(1.04);}product-card:hover .card-gallery:before,product-card:hover .card-gallery:after{opacity:1;transform:none;}}",
    "product-card:focus-within .card-gallery{border-color:#ef6b2e!important;box-shadow:0 0 0 3px rgba(239,107,46,.18),0 18px 38px rgba(18,61,42,.12);}product-card:focus-within .card-gallery:before{opacity:1;transform:none;}",
    ".dpet-menu__panel--expanded .dpet-menu__panel-inner{grid-template-columns:minmax(180px,28%) minmax(0,1fr)!important;gap:clamp(20px,3vw,44px)!important;align-items:start!important;}",
    ".dpet-menu__panel--expanded .dpet-menu__image{width:100%!important;max-height:310px!important;object-fit:contain!important;background:#fff;border-radius:20px;padding:10px;box-shadow:0 10px 28px rgba(18,61,42,.08);}",
    ".dpet-menu__panel--expanded .dpet-menu__links{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:7px 12px!important;margin-top:12px!important;}",
    ".dpet-menu__panel--expanded .dpet-menu__links p{margin:0!important;min-width:0;}",
    ".dpet-menu__panel--expanded .dpet-menu__links a{display:flex!important;align-items:center;min-height:44px;padding:9px 12px!important;border:1px solid rgba(18,61,42,.10);border-radius:12px;background:rgba(255,248,243,.68);color:#123d2a!important;font-weight:650;line-height:1.2;text-decoration:none!important;transition:background-color .18s ease,color .18s ease,border-color .18s ease;}",
    ".dpet-menu__panel--expanded .dpet-menu__links a:before{content:none!important;display:none!important;}",
    ".dpet-menu__panel--expanded .dpet-menu__links a:hover,.dpet-menu__panel--expanded .dpet-menu__links a:focus-visible{background:#ef6b2e;color:#fff!important;border-color:#ef6b2e;transform:none;box-shadow:none;outline:none;}",
    ".facets-toggle__button.dpet-paw-filter{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;flex:0 0 auto!important;width:auto!important;height:auto!important;min-width:100px!important;min-height:44px!important;padding:10px 16px!important;border:1px solid #c46a16!important;border-radius:12px!important;background:#e58a2b!important;color:#123d2a!important;font-size:14px!important;font-weight:650!important;line-height:1.3!important;white-space:nowrap!important;box-shadow:none!important;overflow:visible!important;transition:background-color .2s ease,border-color .2s ease!important;}",
    ".facets-toggle__button.dpet-paw-filter .svg-wrapper{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:18px!important;height:18px!important;flex:0 0 18px!important;color:inherit!important;}",
    ".facets-toggle__button.dpet-paw-filter:before,.facets-toggle__button.dpet-paw-filter:after{content:none!important;display:none!important;}",
    ".facets-toggle__button.dpet-paw-filter:hover{background:#f1a04d!important;border-color:#b45a0b!important;transform:none!important;box-shadow:none!important;}",
    ".facets-toggle__button.dpet-paw-filter:focus-visible{outline:3px solid #123d2a!important;outline-offset:3px!important;}",
    "@media(max-width:749px){product-card .card-gallery{border-radius:16px!important;}product-card .card-gallery img{padding:10px!important;transform:scale(.97);}product-card .card-gallery:before{width:30px;height:30px;top:8px;right:8px;background-size:18px 18px;opacity:0;transform:none;}product-card .card-gallery:after{display:none;}.dpet-menu__panel--expanded .dpet-menu__panel-inner{display:block!important;}.dpet-menu__panel--expanded .dpet-menu__image{max-height:125px!important;margin-bottom:12px!important;}.dpet-menu__panel--expanded .dpet-menu__links{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:7px!important;}.dpet-menu__panel--expanded .dpet-menu__links a{min-height:46px!important;padding:8px 9px!important;border-radius:11px!important;font-size:clamp(12px,3.45vw,14px)!important;}.dpet-menu__panel--expanded .dpet-menu__links a:before{margin-right:5px;}.facets-toggle__button.dpet-paw-filter{min-height:44px!important;padding:10px 14px!important;}}",
    ".dpet-menu__mobile-links--expanded{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:7px!important;padding:12px 8px 14px!important;}",
    ".dpet-menu__mobile-links--expanded p{margin:0!important;min-width:0!important;}",
    ".dpet-menu__mobile-links--expanded a{display:flex!important;align-items:center!important;min-height:42px!important;padding:8px 10px!important;border:1px solid rgba(239,107,46,.24)!important;border-radius:11px!important;background:#fffaf6!important;color:#123d2a!important;font-size:13px!important;font-weight:650!important;line-height:1.25!important;text-decoration:none!important;box-sizing:border-box!important;}",
    ".dpet-menu__mobile-links--expanded a:before{content:none!important;display:none!important;}",
    ".dpet-menu__mobile-links--expanded a:focus-visible{outline:3px solid rgba(239,107,46,.32)!important;outline-offset:2px!important;}",
    "@keyframes dpet-paw-greeting{0%{opacity:0;transform:translateY(5px) rotate(-12deg) scale(.85)}20%,65%{opacity:.9;transform:translateY(0) rotate(0) scale(1)}40%{opacity:.9;transform:translateY(-2px) rotate(8deg) scale(1)}100%{opacity:0;transform:translateY(0) rotate(0) scale(.95)}}@media (max-width:749px),(hover:none){product-card.dpet-paw-reveal .card-gallery:before{animation:dpet-paw-greeting 2.4s ease both;}}",
    "@media(prefers-reduced-motion:reduce){product-card .card-gallery,product-card .card-gallery img,product-card .card-gallery:before,product-card .card-gallery:after,.dpet-menu__links a,.facets-toggle__button{transition:none!important;animation:none!important;transform:none!important;}}"
  ].join('');

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  // Link content is owned by the catalogue navigation below.
  // Styling must not append links that make its observer rebuild on every frame.
  const appendMenuExtras = (links, name, extraClass) => {
    if (links) links.classList.add(extraClass);
  };

  const enhanceMenus = (root = document) => {
    root.querySelectorAll('.dpet-menu__panel').forEach((panel) => {
      const name = (panel.querySelector('.dpet-menu__image')?.alt || panel.querySelector('.dpet-menu__title')?.textContent || '').trim();
      panel.classList.add('dpet-menu__panel--expanded');
      appendMenuExtras(panel.querySelector('.dpet-menu__links'), name, 'dpet-menu__links--expanded');
    });
    root.querySelectorAll('.dpet-menu__mobile-links').forEach((links) => {
      const name = (links.closest('details')?.querySelector('summary')?.textContent || '').trim();
      appendMenuExtras(links, name, 'dpet-menu__mobile-links--expanded');
    });
  };

  const enhanceFilters = (root = document) => {
    root.querySelectorAll('.facets-toggle__button').forEach((button) => {
      button.classList.add('dpet-paw-filter');
      button.setAttribute('aria-label', window.dpetLocaleNavigation.translate('Open filters to refine products'));
      button.title = window.dpetLocaleNavigation.translate('Filter products');
    });
  };

  const pawCards = new WeakSet();
  const pawMotionAllowed = window.matchMedia('(prefers-reduced-motion: no-preference)');
  const pawSmallScreen = window.matchMedia('(max-width:749px), (hover:none)');
  const pawObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || !pawSmallScreen.matches || !pawMotionAllowed.matches) return;
      entry.target.classList.add('dpet-paw-reveal');
      pawObserver.unobserve(entry.target);
    });
  }, {threshold: .35}) : null;
  const enhancePaws = root => {
    if (!pawObserver) return;
    root.querySelectorAll('product-card').forEach(card => {
      if (pawCards.has(card)) return;
      pawCards.add(card);
      pawObserver.observe(card);
    });
  };

  const init = (root = document) => {
    enhancePaws(root);
    enhanceMenus(root);
    enhanceFilters(root);
  };

  const start = () => {
    init(document);
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => init(document), 80);
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  document.addEventListener('shopify:section:load', event => initDpetArrivals(event.target));
  const ensureDpetSocials = () => {
    const footer = document.querySelector('footer');
    if (!footer || footer.querySelector('.dpet-socials')) return;
    const nav = document.createElement('nav');
    nav.className = 'dpet-socials';
    nav.setAttribute('aria-label', 'dPet.mt social profiles');
    nav.innerHTML = '<p class="dpet-socials__label">Follow dPet.mt</p><div class="dpet-socials__icons" role="list"><a class="dpet-socials__icon" role="listitem" href="https://www.facebook.com/dpetmt" target="_blank" rel="noopener noreferrer" title="Follow dPet.mt on Facebook"><i class="fa-brands fa-facebook-f" aria-hidden="true"></i><span class="visually-hidden">Follow dPet.mt on Facebook</span></a><a class="dpet-socials__icon" role="listitem" href="https://www.instagram.com/dpetmt/" target="_blank" rel="noopener noreferrer" title="Follow dPet.mt on Instagram"><i class="fa-brands fa-instagram" aria-hidden="true"></i><span class="visually-hidden">Follow dPet.mt on Instagram</span></a></div>';
    footer.insertBefore(nav, footer.querySelector('.footer-utilities'));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureDpetSocials, {once:true});
  else ensureDpetSocials();
  document.addEventListener('shopify:section:load', ensureDpetSocials);
  const dpetSmileFrameSelector = '#smile-lite-launcher-frame,iframe.smile-launcher-frame';
  const dpetSmileFrames = new WeakSet();
  const styleDpetSmileBadge = frame => {
    const apply = () => {
      try {
        const doc = frame.contentDocument;
        if (!doc?.head || doc.getElementById('dpet-smile-badge-style')) return;
        const badgeStyle = doc.createElement('style');
        badgeStyle.id = 'dpet-smile-badge-style';
        badgeStyle.textContent = ':root{--launcher-color:#e58a2b!important}html,body{margin:0!important;padding:0!important;width:100%!important;height:56px!important;min-height:0!important;max-height:56px!important;background:transparent!important}button{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;width:100%!important;height:56px!important;min-height:56px!important;max-height:56px!important;box-sizing:border-box!important;margin:0!important;padding:0 14px!important;background:#e58a2b!important;color:#123d2a!important;border:1px solid #123d2a24!important;border-radius:28px!important;font-size:14px!important;font-weight:700!important;line-height:1.2!important;white-space:nowrap!important}button:focus-visible{outline:2px solid #123d2a!important;outline-offset:-4px!important}.launcher-container,.launcher-container.background-primary{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;width:100%!important;height:100%!important;min-height:0!important;max-height:56px!important;box-sizing:border-box!important;margin:0!important;padding:0!important;border:0!important;border-radius:inherit!important;background:transparent!important;box-shadow:none!important;color:inherit!important}.launcher-content-container{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important}.launcher-text{display:inline!important;margin:0!important;padding:0!important;color:#123d2a!important;font-size:14px!important;font-weight:700!important;line-height:20px!important;white-space:nowrap!important}button img,button svg,.launcher-icon{width:24px!important;height:24px!important;min-width:24px!important;max-width:24px!important;max-height:24px!important;margin:0!important;padding:0!important;flex-shrink:0!important;object-fit:contain!important;background:transparent!important;color:#123d2a!important}';
        doc.head.append(badgeStyle);
      } catch (_) { /* Cross-origin frames retain their native accessible launcher. */ }
    };
    if (!dpetSmileFrames.has(frame)) {
      dpetSmileFrames.add(frame);
      frame.addEventListener('load', apply);
    }
    apply();
  };
  const startDpetSmileStyle = () => {
    document.querySelectorAll(dpetSmileFrameSelector).forEach(styleDpetSmileBadge);
    // Smile replaces its lightweight launcher after the first open. Watch only
    // newly inserted frame nodes, so a close/reopen never loses the styling.
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches(dpetSmileFrameSelector)) styleDpetSmileBadge(node);
        node.querySelectorAll(dpetSmileFrameSelector).forEach(styleDpetSmileBadge);
      }));
    }).observe(document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startDpetSmileStyle, {once:true});
  else startDpetSmileStyle();
  if (window.Shopify?.designMode) return;
  document.documentElement.classList.add('dpet-content-protection');
  const editable = target => target instanceof Element && target.closest('input,textarea,select,[contenteditable],[role="textbox"]');
  document.addEventListener('contextmenu', event => { if (!editable(event.target)) event.preventDefault(); });
  document.addEventListener('dragstart', event => { if (event.target instanceof HTMLImageElement) event.preventDefault(); });
  document.addEventListener('copy', event => { if (!editable(event.target)) event.preventDefault(); });
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '#MainContent > .shopify-section, #MainContent > .shopify-policy__container > *, .shopify-policy__body > *';
  let observer;
  const clear = () => {
    observer?.disconnect();
    document.querySelectorAll('.dpet-reveal-ready').forEach(section => section.classList.remove('dpet-reveal-ready', 'dpet-reveal-visible'));
  };
  const reveal = () => {
    clear();
    if (motion.matches || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dpet-reveal-visible');
        observer.unobserve(entry.target);
      });
    }, {threshold:0, rootMargin:'0px 0px -12px 0px'});
    document.querySelectorAll(selector).forEach(section => {
      const rect = section.getBoundingClientRect();
      if (rect.height < 24 || rect.top < window.innerHeight || section.contains(document.activeElement)) return;
      section.classList.add('dpet-reveal-ready');
      observer.observe(section);
    });
  };
  document.addEventListener('focusin', event => {
    const section = event.target.closest?.('.dpet-reveal-ready');
    if (section) { section.classList.add('dpet-reveal-visible'); observer?.unobserve(section); }
  });
  motion.addEventListener('change', reveal);
  window.addEventListener('pageshow', reveal);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal, {once:true});
  else reveal();
const dpetInstallCartTerms=()=>{
  if(!document.getElementById('dpet-cart-terms-style')){
    const style=document.createElement('style');
    style.id='dpet-cart-terms-style';
    style.textContent='.dpet-cart-terms{margin:0 0 12px;padding:13px 14px;border:1px solid rgba(239,107,46,.35);border-radius:14px;background:#fff8f3;color:#123d2a;font-size:13px;line-height:1.45}.dpet-cart-terms__row{display:flex;align-items:flex-start;gap:10px}.dpet-cart-terms input{appearance:none;width:19px;height:19px;min-width:19px;margin:1px 0 0;border:2px solid #ef6b2e;border-radius:5px;background:#fff;display:grid;place-content:center;cursor:pointer}.dpet-cart-terms input:checked{background:#ef6b2e}.dpet-cart-terms input:checked:after{content:"✓";color:#fff;font-size:13px;font-weight:900;line-height:1}.dpet-cart-terms a{color:#c95119;font-weight:700;text-decoration:underline;text-underline-offset:2px}.dpet-cart-terms__error{display:none;margin:8px 0 0;color:#c63d2f;font-size:12px;font-weight:700}.dpet-cart-terms--error{border-color:#c63d2f;background:#fff3f1}.dpet-cart-terms--error .dpet-cart-terms__error{display:block}.cart__ctas>#checkout{opacity:1}.cart__ctas:not(.dpet-terms-accepted) .additional-checkout-buttons{filter:grayscale(.18);pointer-events:none}';
    document.head.appendChild(style);
  }
  document.querySelectorAll('.cart__ctas').forEach(ctas=>{
    if(ctas.querySelector('.dpet-cart-terms'))return;
    const checkout=ctas.querySelector('#checkout,[name="checkout"]');
    if(!checkout)return;
    const wrap=document.createElement('div');
    wrap.className='dpet-cart-terms';
    wrap.innerHTML='<label class="dpet-cart-terms__row"><input type="checkbox" class="dpet-cart-terms__check" aria-describedby="dpet-cart-terms-error"><span>I agree to the <a href="/policies/terms-of-service" target="_blank">Terms &amp; Conditions</a>, <a href="/policies/refund-policy" target="_blank">Refund Policy</a>, and <a href="/policies/privacy-policy" target="_blank">Privacy Policy</a>.</span></label><p class="dpet-cart-terms__error" id="dpet-cart-terms-error" role="alert">Please accept the policies before checkout.</p>';
    ctas.insertBefore(wrap,checkout);
    const error=wrap.querySelector('.dpet-cart-terms__error');
    const uniqueId='dpet-terms-'+Math.random().toString(36).slice(2);
    error.id=uniqueId;
    wrap.querySelector('input').setAttribute('aria-describedby',uniqueId);
    ctas.classList.remove('dpet-terms-accepted');
  });
};
// Read the current checkbox at event time: cart updates replace its DOM nodes.
const dpetTermsRegion=target=>target?.closest?.('.cart__ctas');
const dpetTermsGuard=(event,region)=>{
  if(!region)return;
  const check=region.querySelector('.dpet-cart-terms__check');
  if(!check || check.checked)return;
  event.preventDefault();event.stopImmediatePropagation();
  region.querySelector('.dpet-cart-terms')?.classList.add('dpet-cart-terms--error');
  check.focus();
};
document.addEventListener('change',event=>{
  if(!event.target.matches('.dpet-cart-terms__check'))return;
  const region=dpetTermsRegion(event.target);
  region?.classList.toggle('dpet-terms-accepted',event.target.checked);
  region?.querySelector('.dpet-cart-terms')?.classList.remove('dpet-cart-terms--error');
},true);
document.addEventListener('click',event=>{
  const button=event.target.closest?.('[name="checkout"],.additional-checkout-buttons');
  if(button)dpetTermsGuard(event,dpetTermsRegion(button));
},true);
document.addEventListener('submit',event=>{
  if(event.submitter?.name==='checkout')dpetTermsGuard(event,dpetTermsRegion(event.submitter));
},true);

document.addEventListener('DOMContentLoaded',dpetInstallCartTerms);
document.addEventListener('shopify:section:load',dpetInstallCartTerms);
new MutationObserver(()=>requestAnimationFrame(dpetInstallCartTerms)).observe(document.documentElement,{childList:true,subtree:true});
dpetInstallCartTerms();

  /* dPet.mt interactive launch offers page — 2026-10 */
  const installLaunchOffers = () => {
    const t = window.dpetLocaleNavigation.translate;
    document.querySelectorAll('.dpet-menu__title').forEach((link) => { if (['Offers', 'Offerti'].includes((link.textContent || '').trim())) link.href = window.dpetLocaleNavigation.href('/pages/offers'); });
    if (window.dpetLocaleNavigation.path().replace(/\/$/, '') !== '/pages/offers') return;
    const main = document.querySelector('#MainContent');
    if (!main || main.querySelector('.dpet-launch-offers')) return;
    if (!document.getElementById('dpet-launch-offers-style')) {
      const style = document.createElement('style');
      style.id = 'dpet-launch-offers-style';
      style.textContent = '.dpet-launch-offers{--orange:#ef6b2e;--green:#123d2a;--cream:#fff8f1;color:var(--green);overflow:hidden}.dpet-offers-hero{position:relative;padding:clamp(56px,8vw,108px) 20px 64px;text-align:center;background:radial-gradient(circle at 10% 15%,rgba(239,107,46,.18),transparent 32%),radial-gradient(circle at 90% 25%,rgba(18,61,42,.14),transparent 28%),linear-gradient(135deg,#fffaf5,#f4fbf6);isolation:isolate}.dpet-offers-hero:before,.dpet-offers-hero:after{position:absolute;color:rgba(239,107,46,.16);font-size:clamp(76px,12vw,160px);line-height:1;z-index:-1}.dpet-offers-hero:before{content:"🐾";left:-16px;bottom:-30px;transform:rotate(-18deg)}.dpet-offers-hero:after{content:"🐾";right:-8px;top:0;transform:rotate(18deg)}.dpet-offers-kicker{display:inline-flex;align-items:center;gap:8px;margin:0 0 15px;padding:8px 14px;border-radius:999px;background:#fff;border:1px solid rgba(239,107,46,.25);color:#c95019;font-size:13px;font-weight:800;letter-spacing:.04em;text-transform:none}.dpet-offers-hero h1{max-width:920px;margin:0 auto 18px;font-size:clamp(38px,6vw,72px);line-height:1.02;letter-spacing:-.045em}.dpet-offers-hero p{max-width:720px;margin:0 auto;color:#456356;font-size:clamp(17px,2vw,21px);line-height:1.55}.dpet-offers-perks{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px;max-width:1180px;margin:-34px auto 58px;padding:0 20px;position:relative;z-index:2}.dpet-offers-perk{display:flex;align-items:center;gap:14px;min-height:118px;padding:22px;border:1px solid rgba(18,61,42,.10);border-radius:22px;background:#fff;box-shadow:0 16px 40px rgba(18,61,42,.09);text-decoration:none;color:var(--green);transition:transform .3s ease,box-shadow .3s ease,border-color .3s ease}.dpet-offers-perk:hover{transform:translateY(-5px);box-shadow:0 22px 45px rgba(18,61,42,.14);border-color:rgba(239,107,46,.45)}.dpet-offers-perk .dpet-offers-perk__icon{display:grid;place-items:center;flex:0 0 54px;width:54px;height:54px;border-radius:18px;background:linear-gradient(145deg,#fff8f2,#ffe3cf);color:var(--orange);border:1px solid rgba(239,107,46,.24);box-shadow:inset 0 1px 0 #fff,0 8px 20px rgba(18,61,42,.08);font-size:0}.dpet-offers-perk__icon svg{display:block;width:28px;height:28px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}.dpet-offers-perk strong{display:block;margin-bottom:5px;font-size:17px}.dpet-offers-perk span{display:block;color:#60756b;font-size:13px;line-height:1.45}.dpet-offers-wrap{max-width:1220px;margin:0 auto;padding:0 20px 84px}.dpet-offers-heading{text-align:center;margin:0 auto 34px}.dpet-offers-heading h2{margin:0 0 9px;font-size:clamp(30px,4vw,48px);letter-spacing:-.035em}.dpet-offers-heading p{margin:0;color:#60756b}.dpet-offers-grid{display:grid;gap:24px}.dpet-offer-card{position:relative;display:grid;grid-template-columns:220px 1fr;gap:26px;padding:28px;border:1px solid rgba(18,61,42,.11);border-radius:28px;background:linear-gradient(145deg,#fff,#fffaf6);box-shadow:0 14px 38px rgba(18,61,42,.07);overflow:hidden;transition:transform .35s ease,box-shadow .35s ease}.dpet-offer-card:hover{transform:translateY(-4px);box-shadow:0 22px 52px rgba(18,61,42,.12)}.dpet-offer-card:after{content:"";position:absolute;right:-45px;top:-45px;width:120px;height:120px;border:22px solid rgba(239,107,46,.08);border-radius:50%}.dpet-offer-brand{display:flex;flex-direction:column;align-items:flex-start;justify-content:center;gap:15px;padding:20px;border-radius:22px;background:#fff;border:1px solid rgba(239,107,46,.18)}.dpet-offer-logo{width:100%;height:82px;object-fit:contain;object-position:center}.dpet-offer-card[data-brand="farmina"] .dpet-offer-logo,.dpet-offer-card[data-brand="schesir"] .dpet-offer-logo{transform:scale(1.25)}.dpet-offer-wordmark{display:grid;place-items:center;width:100%;height:72px;border-radius:16px;background:linear-gradient(135deg,#0b8b43,#73bc2d);color:#fff;font-size:30px;font-weight:900;letter-spacing:.04em}.dpet-offer-badge{display:inline-flex;align-items:center;padding:7px 11px;border-radius:999px;background:var(--orange);color:#fff;font-size:12px;font-weight:900;letter-spacing:.05em;text-transform:uppercase}.dpet-offer-copy h3{margin:2px 0 6px;font-size:clamp(24px,3vw,34px);letter-spacing:-.025em}.dpet-offer-copy>p{margin:0 0 18px;color:#597064}.dpet-offer-products{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:11px}.dpet-offer-product{display:flex;flex-direction:column;min-width:0;padding:10px;border:1px solid rgba(18,61,42,.09);border-radius:16px;background:#fff;color:var(--green);text-decoration:none;transition:transform .25s ease,border-color .25s ease}.dpet-offer-product:hover{transform:translateY(-3px) rotate(-.5deg);border-color:rgba(239,107,46,.55)}.dpet-offer-product img{width:100%;aspect-ratio:1/1;object-fit:contain;border-radius:11px;background:#fff;padding:7px;box-sizing:border-box}.dpet-offer-product strong{display:-webkit-box;margin:8px 0 5px;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-size:12px;line-height:1.3}.dpet-offer-product span{margin-top:auto;color:#c95019;font-size:13px;font-weight:850}.dpet-offer-loading{grid-column:1/-1;margin:8px 0;color:#7b8d84;font-size:13px}.dpet-offer-cta{display:inline-flex;align-items:center;justify-content:center;margin-top:18px;padding:12px 18px;border-radius:14px;background:var(--green);color:#fff;text-decoration:none;font-weight:850;transition:transform .25s ease,background .25s ease}.dpet-offer-cta:hover{background:#ef6b2e;transform:translateX(3px)}.dpet-offers-note{margin:34px auto 0;padding:22px 24px;border:2px dashed rgba(239,107,46,.36);border-radius:22px;background:var(--cream);text-align:center}.dpet-offers-note strong{font-size:19px}.dpet-offers-note p{margin:7px 0 0;color:#5f7169}.dpet-rewards-open{appearance:none;border:0;background:none;padding:0;text-align:left;font:inherit;cursor:pointer}.dpet-rewards-open .dpet-offers-perk{width:100%}@media(max-width:900px){.dpet-offer-card{grid-template-columns:1fr}.dpet-offer-brand{flex-direction:row;align-items:center}.dpet-offer-logo,.dpet-offer-wordmark{width:min(190px,100%);height:72px;margin:auto}.dpet-offer-products{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:700px){.dpet-offers-perks{grid-template-columns:1fr;margin-top:-24px}.dpet-offers-perk{min-height:auto}.dpet-offers-wrap{padding-inline:14px}.dpet-offer-card{padding:17px;border-radius:22px}.dpet-offer-brand{padding:14px}.dpet-offer-products{grid-auto-flow:column;grid-auto-columns:minmax(145px,70%);grid-template-columns:none;overflow-x:auto;scroll-snap-type:x mandatory;padding-bottom:8px}.dpet-offer-product{scroll-snap-align:start}.dpet-offers-hero{padding-inline:16px}}@media(prefers-reduced-motion:reduce){.dpet-offers-perk,.dpet-offer-card,.dpet-offer-product,.dpet-offer-cta{transition:none!important;transform:none!important}}';
      document.head.appendChild(style);
    }
    main.innerHTML = '<div class="dpet-launch-offers"><section class="dpet-offers-hero"><p class="dpet-offers-kicker">Little extras. Happier pets.</p><h1>dPet Offers</h1><p>Mix your pets’ favourites, unlock automatic savings and enjoy thoughtful service across Malta and Gozo.</p></section><section class="dpet-offers-perks" aria-label="dPet.mt shopping benefits"><a class="dpet-offers-perk" href="/policies/shipping-policy"><span class="dpet-offers-perk__icon" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h10v10H3zM13 10h4l4 4v2.5h-1.5M13 16.5H8.5"/><circle cx="6.5" cy="17" r="2"/><circle cx="17.5" cy="17" r="2"/></svg></span><span><strong>Free next working day delivery</strong><span>Across Malta and Gozo on orders of €45 or more.</span></span></a><button class="dpet-rewards-open" type="button"><span class="dpet-offers-perk"><span class="dpet-offers-perk__icon" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="7" r="2"/><circle cx="16" cy="7" r="2"/><circle cx="5.5" cy="11.5" r="1.7"/><circle cx="18.5" cy="11.5" r="1.7"/><path d="M8 16.5c0-2.5 1.8-4.5 4-4.5s4 2 4 4.5c0 1.8-1.4 3-4 3s-4-1.2-4-3z"/></svg></span><span><strong>3 points for every €1</strong><span>100 dRewards points gives you €1 off a future purchase.</span></span></span></button><div class="dpet-offers-perk"><span class="dpet-offers-perk__icon" aria-hidden="true"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 10h17v10h-17zM2.5 7h19v3h-19zM12 7v13M12 7H7.5A2.5 2.5 0 1 1 10 4.5C10 5.9 12 7 12 7zM12 7h4.5A2.5 2.5 0 1 0 14 4.5C14 5.9 12 7 12 7z"/></svg></span><span><strong>A small surprise inside</strong><span>Expect a little thank-you from us in your box.</span></span></div></section><section class="dpet-offers-wrap"><header class="dpet-offers-heading"><h2>Automatic launch savings</h2><p>No code needed. Mix and match qualifying products within each brand.</p></header><div class="dpet-offers-grid" id="dpet-launch-offer-grid"></div><aside class="dpet-offers-note"><strong>Made for Malta’s pet families</strong><p>Savings appear automatically at checkout when the quantity is met. Offers are subject to availability while the launch promotion is active.</p></aside></section></div>';
    if (window.dpetLocaleNavigation.isMaltese) {
      const copy = [
        [
          ".dpet-offers-kicker",
          "Little extras. Happier pets."
        ],
        [
          ".dpet-offers-hero h1",
          "dPet Offers"
        ],
        [
          ".dpet-offers-hero > p:last-child",
          "Mix your pets’ favourites, unlock automatic savings and enjoy thoughtful service across Malta and Gozo."
        ],
        [
          ".dpet-offers-perks > a strong",
          "Free next working day delivery"
        ],
        [
          ".dpet-offers-perks > a .dpet-offers-perk__icon + span > span",
          "Across Malta and Gozo on orders of €45 or more."
        ],
        [
          ".dpet-rewards-open strong",
          "3 points for every €1"
        ],
        [
          ".dpet-rewards-open .dpet-offers-perk__icon + span > span",
          "100 dRewards points gives you €1 off a future purchase."
        ],
        [
          ".dpet-offers-perks > div strong",
          "A small surprise inside"
        ],
        [
          ".dpet-offers-perks > div .dpet-offers-perk__icon + span > span",
          "Expect a little thank-you from us in your box."
        ],
        [
          ".dpet-offers-heading h2",
          "Automatic launch savings"
        ],
        [
          ".dpet-offers-heading p",
          "No code needed. Mix and match qualifying products within each brand."
        ],
        [
          ".dpet-offers-note strong",
          "Made for Malta’s pet families"
        ],
        [
          ".dpet-offers-note p",
          "Savings appear automatically at checkout when the quantity is met. Offers are subject to availability while the launch promotion is active."
        ]
      ];
      copy.forEach(([selector, source]) => {
        const node = main.querySelector(selector);
        if (node) node.textContent = t(source);
      });
      main.querySelector('.dpet-offers-perks')?.setAttribute('aria-label', t('dPet.mt shopping benefits'));
    }
    const offers = [
      {name:'Schesir',handle:'schesir-launch-offer',qty:5,pct:3,logo:'https://dpet.mt/cdn/shop/files/dpet-brand-schesir.png?v=1790980032&width=440'},
      {name:'Farmina',handle:'farmina-launch-offer',qty:3,pct:3,logo:'https://dpet.mt/cdn/shop/files/dpet-brand-farmina.png?v=1790980033&width=440'},
      {name:'Askoll',handle:'askoll-launch-offer',qty:3,pct:5,logo:'https://dpet.mt/cdn/shop/files/dpet-brand-askoll.png?v=1790980033&width=440',featured:['askoll-acqua-amica-aquarium-water-conditioner-250ml','askoll-ultrafast-bio-active-bacterial-additive-250ml','askoll-verde-incanto-liquid-plant-nutrition-100ml','askoll-co2-pro-green-system-complete-co2-kit-up-to-200l']},
      {name:'ZuPreem',handle:'zupreem-launch-offer',qty:2,pct:3,logo:'https://dpet.mt/cdn/shop/files/dpet-brand-zupreem.png?v=1790980033&width=440'},
      {name:'Claber',handle:'claber-launch-offer',qty:3,pct:5,logo:'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-brand-claber.png?v=1791032888'}
    ];
    const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    const money = (value) => Number(value || 0).toLocaleString('en-MT',{style:'currency',currency:'EUR'});
    const grid = main.querySelector('#dpet-launch-offer-grid');
    offers.forEach((offer) => {
      const card = document.createElement('article');
      card.className = 'dpet-offer-card'; card.dataset.brand = offer.name.toLowerCase();
      const logo = offer.logo ? '<img class="dpet-offer-logo" src="'+esc(offer.logo)+'" alt="'+esc(offer.name)+' logo" loading="lazy">' : '<span class="dpet-offer-wordmark" aria-label="Claber">CLABER</span>';
      card.innerHTML = '<div class="dpet-offer-brand">'+logo+'<span class="dpet-offer-badge">Buy '+offer.qty+' · save '+offer.pct+'%</span></div><div class="dpet-offer-copy"><h3>'+esc(offer.name)+' launch bundle</h3><p>Add any '+offer.qty+' qualifying '+esc(offer.name)+' products and get '+offer.pct+'% off automatically.</p><div class="dpet-offer-products"><p class="dpet-offer-loading">'+esc(t('Loading customer favourites…'))+'</p></div><a class="dpet-offer-cta" href="/collections/'+esc(offer.handle)+'">Shop '+esc(offer.name)+'</a></div>';
      if (window.dpetLocaleNavigation.isMaltese) {
        const values = { brand: offer.name, qty: offer.qty, pct: offer.pct };
        card.querySelector('.dpet-offer-badge').textContent = t('Buy {qty} · save {pct}%', values);
        card.querySelector('.dpet-offer-copy h3').textContent = t('{brand} launch bundle', values);
        card.querySelector('.dpet-offer-copy > p').textContent = t('Add any {qty} qualifying {brand} products and get {pct}% off automatically.', values);
        card.querySelector('.dpet-offer-cta').textContent = t('Shop {brand}', values);
      }
      grid.appendChild(card);
      (offer.featured ? Promise.all(offer.featured.map((handle) => fetch(window.dpetLocaleNavigation.href('/products/'+handle+'.js')).then((response) => response.ok ? response.json() : Promise.reject()))).then((products) => ({products})) : fetch(window.dpetLocaleNavigation.href('/collections/'+offer.handle+'/products.json?limit=4')).then((response) => response.ok ? response.json() : Promise.reject())).then((data) => {
        const products = (data.products || []).slice(0,4);
        const tray = card.querySelector('.dpet-offer-products');
        if (!products.length) { tray.innerHTML = '<p class="dpet-offer-loading">'+esc(t('Products are being prepared for this offer.'))+'</p>'; return; }
        tray.innerHTML = products.map((product) => { const image = product.featured_image || product.images?.[0]?.src || product.images?.[0] || ''; const rawPrice = product.variants?.[0]?.price; const price = offer.featured && Number.isInteger(rawPrice) ? rawPrice / 100 : rawPrice; return '<a class="dpet-offer-product" href="/products/'+esc(product.handle)+'"><img src="'+esc(image)+'" alt="'+esc(product.title)+'" loading="lazy"><strong>'+esc(product.title.replace(/\s*\|\s*dPet Malta$/i,''))+'</strong><span>'+money(price)+'</span></a>'; }).join('');
      }).catch(() => { card.querySelector('.dpet-offer-products').innerHTML = '<p class="dpet-offer-loading">'+esc(t('Explore the full qualifying range below.'))+'</p>'; });
    });
    main.querySelector('.dpet-rewards-open')?.addEventListener('click', (event) => { const trigger = Array.from(document.querySelectorAll('button')).find((button) => button !== event.currentTarget && (button.textContent || '').trim() === 'dRewards'); trigger?.click(); });
  };
  document.addEventListener('DOMContentLoaded', installLaunchOffers, {once:true});
  document.addEventListener('shopify:section:load', installLaunchOffers);
  installLaunchOffers();
})();

/* dPet.mt grid slideshow and mega-menu polish — 2026-10 */
(() => {
  const PATCH_ID = 'dpet-grid-menu-v2';
  if (!document.getElementById(PATCH_ID)) {
    const style = document.createElement('style');
    style.id = PATCH_ID;
    style.textContent = [
      'product-card .card-gallery slideshow-component,product-card .card-gallery slideshow-container,product-card .card-gallery slideshow-slides,product-card .card-gallery slideshow-slide{width:100%!important;height:100%!important;min-height:100%!important;}',
      'product-card .card-gallery slideshow-component,product-card .card-gallery slideshow-container{display:block!important;position:relative!important;}',
      'product-card .card-gallery slideshow-slides{display:flex!important;position:relative!important;}',
      'product-card .card-gallery slideshow-slide{inset:0!important;}',
      '.dpet-menu__panel--expanded .dpet-menu__image{aspect-ratio:1/1!important;height:auto!important;max-height:none!important;object-fit:contain!important;object-position:center!important;background:#fff!important;border:1px solid rgba(18,61,42,.10)!important;border-radius:22px!important;padding:clamp(12px,1.4vw,20px)!important;box-sizing:border-box!important;box-shadow:0 12px 30px rgba(18,61,42,.10)!important;}',
      '@media(min-width:750px){.dpet-menu__panel--expanded .dpet-menu__panel-inner{grid-template-columns:minmax(210px,25%) minmax(0,1fr)!important;}.dpet-menu__panel--expanded .dpet-menu__image{max-width:300px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  const menuImages = {
    Dogs: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-dogs-v4.png?v=1791035158',
    Cats: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-cats-v4.png?v=1791035159',
    Birds: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-birds-v4.png?v=1791035158',
    Fish: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-fish-v4.png?v=1791035158',
    Rodents: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-small-pets-v4.png?v=1791035159',
    Reptiles: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-reptiles-v4.png?v=1791035158',
    Garden: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-garden-v4.png?v=1791035159',
    Info: 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-journal-v4.png?v=1791035158',
    'dPet Offers': 'https://cdn.shopify.com/s/files/1/1016/9483/3022/files/dpet-mega-offers-v4.png?v=1791035158'
  };

  const polishMenu = () => {
    document.querySelectorAll('dpet-header-menu,.dpet-menu__drawer-categories').forEach((menu) => {
      menu.querySelectorAll('.dpet-menu__image').forEach((img) => {
        const src = menuImages[img.alt];
        if (!src || img.dataset.dpetPremiumImage === 'true') return;
        img.src = src;
        img.removeAttribute('srcset');
        img.width = 720;
        img.height = 720;
        img.dataset.dpetPremiumImage = 'true';
      });
      menu.querySelectorAll('.dpet-menu__title').forEach((link) => {
        const label = link.textContent.trim();
        if (label === 'Garden') link.setAttribute('href', '/collections/garden-supplies-malta');
        if (label === 'Info') link.setAttribute('href', '/#dpet-about');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', polishMenu, {once:true});
  else polishMenu();
  document.addEventListener('shopify:section:load', polishMenu);
  const header = document.querySelector('#header-component');
  if (header) {
    setTimeout(polishMenu, 800);
    document.addEventListener('click', () => {
      setTimeout(polishMenu, 100);
      setTimeout(polishMenu, 900);
    }, true);
  }
})();


/* dPet.mt product price delivery note — 2026-10 */
(() => {
  const installPriceNote = () => {
    if (!window.dpetLocaleNavigation.path().startsWith('/products/')) return;
    document.querySelectorAll('main product-price').forEach((price) => {
      if (price.nextElementSibling?.classList.contains('dpet-price-note')) return;
      const note = document.createElement('p');
      note.className = 'dpet-price-note';
      const t = window.dpetLocaleNavigation.translate;
      note.innerHTML = t('Taxes included.') + ' <a href="/policies/shipping-policy">' + t('Shipping') + '</a> ' + t('calculated at checkout.');
      price.insertAdjacentElement('afterend', note);
    });
  };
  if (!document.getElementById('dpet-price-note-style')) {
    const style = document.createElement('style');
    style.id = 'dpet-price-note-style';
    style.textContent = '.dpet-price-note{margin:-4px 0 2px;color:rgba(18,61,42,.72);font-size:clamp(1.25rem,1.2vw,1.45rem);line-height:1.45;letter-spacing:.01em}.dpet-price-note a{color:#e8753d;text-decoration:underline;text-decoration-thickness:2px;text-underline-offset:4px;font-weight:700}.dpet-price-note a:hover{color:#123d2a}';
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installPriceNote, {once:true});
  else installPriceNote();
  document.addEventListener('shopify:section:load', installPriceNote);
})();


/* dPet.mt precise catalogue navigation and theme-wide breadcrumbs — 2026-10 */
(() => {
  const PATCH_ID = 'dpet-catalog-navigation-v3';
  const groups = {
    Dogs: [
      ['/collections/premium-dog-supplies','Dog essentials'],
      ['/collections/xn-pawfit-dog-cat-gps-trackers-veb','Pawfit GPS trackers'],
      ['/collections/dog-food','Food & nutrition'],
      ['/collections/dog-treats','Treats & rewards'],
      ['/collections/dog-feeding-drinking-bowls','Bowls, feeders & water'],
      ['/collections/dog-toys','Toys & enrichment'],
      ['/collections/dog-collars-leashes','Collars, harnesses & leads'],
      ['/collections/dog-grooming-health','Grooming & wellbeing'],
      ['/collections/dog-training-pads-toilets','Training & toilet care'],
      ['/collections/dog-beds','Beds & rest'],
      ['/collections/dog-kennels-playpens','Kennels & playpens'],
      ['/collections/dog-pools-pet-cooling-mats','Summer & cooling essentials'],
      ['/collections/dog-calming-support','Calming support']
    ],
    Cats: [
      ['/collections/cats','Cat essentials'],
      ['/collections/xn-pawfit-dog-cat-gps-trackers-veb','Pawfit GPS trackers'],
      ['/collections/cat-dry-food','Food & nutrition'],
      ['/collections/cat-treats','Treats & rewards'],
      ['/collections/cat-feeding-drinking-bowls','Bowls, feeders & water'],
      ['/collections/cat-kitten-collars-malta','Collars & safety'],
      ['/collections/cat-and-kitten-toys','Toys & scratching'],
      ['/collections/cat-grooming-health','Grooming & wellbeing'],
      ['/collections/cat-litter-accessories','Litter & home care'],
      ['/collections/cat-kitten-beds-cushions','Beds & cosy spaces'],
      ['/collections/cat-calming-support','Calming & support'],
      ['/collections/cat-carriers-travel','Carriers & travel']
    ],
    Birds: [
      ['/collections/birds','Explore bird essentials'],
      ['/collections/premium-bird-parrot-food','Food & nutrition'],
      ['/collections/zupreem-bird-parrot-food-malta','ZuPreem'],
      ['/collections/lafeber-bird-parrot-food-malta','Lafeber'],
      ['/collections/tops-organic-parrot-food','TOP’s'],
      ['/collections/witte-mollen-puur','PUUR'],
      ['/collections/cunipic-bird-food','CuniPic'],
      ['/collections/birdparrot-toys','Toys & enrichment'],
      ['/collections/parrotbird-cages','Cages & aviaries'],
      ['/collections/bird-parrot-feeding-drinking-accessories','Feeders & drinkers'],
      ['/collections/bird-parrot-perches','Perches & natural enrichment'],
      ['/collections/bird-parrot-supplements-breeding-care','Health & supplements'],
      ['/collections/bird-parrot-cleaning-hygiene','Care & hygiene']
    ],
    Fish: [
      ['/collections/fish-aquarium-supplies-malta','Fishkeeping essentials'],
      ['/collections/askoll-premium-complete-aquariums','Complete Askoll aquariums'],
      ['/collections/tropical-fish-food','Fish food & nutrition'],
      ['/collections/pond-turtle-terrapin-food','Turtle & terrapin food'],
      ['/collections/filtration-water-quality','Filtration & water quality'],
      ['/collections/aquarium-water-treatments-filtration-media','Water care & filter media'],
      ['/collections/aquarium-cleaning','Cleaning & maintenance'],
      ['/collections/aquarium-decorations-malta','Décor & aquascaping'],
      ['/collections/aquarium-led-lighting-fish-tank-lights-malta','LED lighting'],
      ['/collections/aquarium-plant-care-fertilisers-co2-systems-malta','Plant care & CO₂'],
      ['/collections/aquarium-water-quality-test','Water testing'],
      ['/collections/aquarium-fish-treatments','Fish treatments']
    ],
    Rodents: [
      ['/collections/rodent_supplies_malta','Explore small-pet essentials'],
      ['/collections/rodents-small-animal-food','Food & daily nutrition'],
      ['/collections/premium-small-pet-hay-fiber','Hay & fibre'],
      ['/collections/rodent-bedding-litter','Bedding & litter'],
      ['/collections/rodents-small-animals-feeding-bowls','Bowls & bottles'],
      ['/collections/rodent-small-pet-cages-malta','Cages & habitats'],
      ['/collections/rodent-small-pets-toys','Play & enrichment'],
      ['/collections/small-pets-natural-treats-foraging-snacks','Treats & chews'],
      ['/collections/rodent-health-and-hygiene','Health & hygiene']
    ],
    Reptiles: [
      ['/collections/reptile-food-and-accessories-malta','Explore reptile essentials'],
      ['/collections/reptile-food','Food & nutrition'],
      ['/collections/reptile-accessories-malta','Habitat accessories'],
      ['/collections/turtle-food-care-malta','Turtle food & care'],
      ['/collections/reptile-heating-lighting','Heating & lighting'],
      ['/collections/reptile-terrariums-habitats','Terrariums & habitats'],
      ['/collections/reptile-care-habitat','Care & habitat']
    ],
    Garden: [
      ['/collections/garden-supplies-malta','Explore garden essentials'],
      ['/collections/garden-soil-compost-plant-care','Soil, compost & plant care'],
      ['/collections/watering-irrigation','Watering & irrigation'],
      ['/collections/pots-planters','Pots, planters & saucers'],
      ['/collections/garden-tools-maintenance','Garden tools'],
      ['/collections/professional-pest-control-products-malta','Garden & pest control'],
      ['/collections/summer-garden-care-irrigation','Summer garden care'],
      ['/collections/garden-growing-care','Growing & garden care']
    ],
    'dPet Offers': [
      ['/collections/all','All dPet.mt essentials'],
      ['/collections/deals','Current offers'],
      ['/pages/offers','dPet Offers'],
      ['/collections/hot-arrivals','Hot arrivals'],
      ['/collections/all?sort_by=best-selling','Featured picks'],
      ['/collections/new-arrivals','New at dPet.mt'],
      ['/collections/malta-pet-summer-collection','Summer essentials'],
      ['/collections/autumn-winter-pet-essentials','Autumn & winter essentials'],
      ['/collections/halloween-pet-collection','Halloween collection'],
      ['/products/dpet-digital-gift-card','Digital gift cards']
    ]
  };

  const getLabel = (container) => {
    const item = container.closest('.dpet-menu__item');
    if (item) return (item.querySelector('.dpet-menu__trigger')?.textContent || '').trim();
    const details = container.closest('details');
    return (details?.querySelector(':scope > summary')?.textContent || '').trim();
  };

  const groupPaths = new Map(Object.entries(groups).map(([key, items]) => [items[0][0].split('?')[0], key]).filter(([path]) => path !== '/collections/all'));
  groupPaths.set('/pages/offers', 'dPet Offers');
  const groupAliases = {
    dogs: 'Dogs', klieb: 'Dogs', cats: 'Cats', qtates: 'Cats', birds: 'Birds', għasafar: 'Birds',
    fish: 'Fish', ħut: 'Fish', rodents: 'Rodents', gerriema: 'Rodents', 'annimali żgħar': 'Rodents',
    reptiles: 'Reptiles', rettili: 'Reptiles', garden: 'Garden', ġnien: 'Garden',
    'dpet offers': 'dPet Offers', offers: 'dPet Offers', offerti: 'dPet Offers',
    'offerti dpet': 'dPet Offers', 'offerti ta’ dpet.mt': 'dPet Offers'
  };
  const getGroup = (container) => {
    if (groups[container.dataset.dpetGroup]) return container.dataset.dpetGroup;
    const title = container.closest('.dpet-menu__item')?.querySelector('.dpet-menu__title[href]');
    const firstLink = container.querySelector('a[href]');
    let key;
    for (const link of [title, firstLink]) {
      if (!link) continue;
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        if (url.origin !== location.origin) continue;
        key = groupPaths.get(window.dpetLocaleNavigation.path(url.pathname).replace(/\/$/, ''));
      } catch (_) { /* A label alias can still identify a temporarily incomplete menu. */ }
      if (key) break;
    }
    key = key || groupAliases[getLabel(container).normalize('NFC').toLowerCase()];
    if (key) container.dataset.dpetGroup = key;
    return key;
  };

  const rebuildMenus = () => {
    document.querySelectorAll('.dpet-menu__links, .dpet-menu__mobile-links').forEach((container) => {
      const items = groups[getGroup(container)];
      if (getGroup(container) === 'Garden') return;
      if (!items) return;
      const displayItems = items.map(([href, label]) => [window.dpetLocaleNavigation.href(href), window.dpetLocaleNavigation.translate(label)]);
      const signature = displayItems.map((item) => item[0] + '|' + item[1]).join('||');
      const current = Array.from(container.querySelectorAll(':scope > p > a')).map((link) => (link.getAttribute('href') || '') + '|' + (link.textContent || '').trim()).join('||');
      if (current === signature) return;
      container.replaceChildren();
      displayItems.forEach((item, index) => {
        const paragraph = document.createElement('p');
        if (index > 7) paragraph.className = 'dpet-menu__extra';
        const link = document.createElement('a');
        link.href = item[0];
        link.textContent = item[1];
        paragraph.appendChild(link);
        container.appendChild(paragraph);
      });
      container.classList.add(container.classList.contains('dpet-menu__mobile-links') ? 'dpet-menu__mobile-links--expanded' : 'dpet-menu__links--expanded');
    });
  };

  const addBreadcrumbs = () => {
    if (window.dpetLocaleNavigation.path() === '/' || document.querySelector('.dpet-breadcrumbs')) return;
    const main = document.querySelector('#MainContent, main');
    if (!main) return;
    const title = (document.querySelector('main h1, #MainContent h1')?.textContent || document.title.split('|')[0] || 'dPet.mt').trim();
    const path = window.dpetLocaleNavigation.path();
    const t = window.dpetLocaleNavigation.translate;
    const items = [['/',t('Home')]];
    if (path.startsWith('/products/')) items.push(['/collections/all',t('Products')]);
    else if (path.startsWith('/articles/')) items.push(['/blogs/news','dPet Jurnal']);
    else if (path.startsWith('/blogs/') && path.split('/').filter(Boolean).length > 2) items.push(['/blogs/news','dPet Jurnal']);
    else if (path.startsWith('/policies/')) items.push(['/pages/legal-notice',t('Policies')]);
    items.push([null,title]);
    const nav = document.createElement('nav');
    nav.className = 'dpet-breadcrumbs';
    nav.setAttribute('aria-label',t('Breadcrumbs'));
    const list = document.createElement('ol');
    items.forEach((item, index) => {
      const entry = document.createElement('li');
      if (item[0] && index < items.length - 1) {
        const link = document.createElement('a');
        link.href = window.dpetLocaleNavigation.href(item[0]);
        link.textContent = item[1];
        entry.appendChild(link);
      } else {
        const current = document.createElement('span');
        current.textContent = item[1];
        current.setAttribute('aria-current','page');
        entry.appendChild(current);
      }
      list.appendChild(entry);
    });
    nav.appendChild(list);
    main.before(nav);
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.textContent = JSON.stringify({
      '@context':'https://schema.org',
      '@type':'BreadcrumbList',
      itemListElement: items.map((item, index) => ({
        '@type':'ListItem',
        position:index + 1,
        name:item[1],
        item:item[0] ? location.origin + window.dpetLocaleNavigation.href(item[0]) : location.href
      }))
    });
    document.head.appendChild(schema);
  };

  const install = () => {
    if (!document.getElementById(PATCH_ID)) {
      const style = document.createElement('style');
      style.id = PATCH_ID;
      style.textContent = '.dpet-menu__links{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:.15rem 1.25rem!important}.dpet-menu__links>p,.dpet-menu__mobile-links>p{margin:0!important}.dpet-breadcrumbs{width:min(100%,1440px);margin:0 auto;padding:1rem clamp(1rem,4vw,3rem);font-size:.9rem;color:#49675b}.dpet-breadcrumbs ol{display:flex;align-items:center;gap:.5rem;list-style:none;margin:0;padding:0;white-space:nowrap;overflow:hidden}.dpet-breadcrumbs li{display:flex;align-items:center;min-width:0;flex:0 0 auto}.dpet-breadcrumbs li:last-child{flex:1 1 auto}.dpet-breadcrumbs li+li:before{content:"/";color:#9a8f84;font-weight:600;margin-right:.5rem;flex:none}.dpet-breadcrumbs a{color:#176044;text-decoration:none;font-weight:700}.dpet-breadcrumbs a:hover{text-decoration:underline;text-decoration-color:#ef6f25;text-underline-offset:.25em}.dpet-breadcrumbs [aria-current="page"]{display:block;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media(max-width:749px){.dpet-menu__links{grid-template-columns:1fr!important}.dpet-breadcrumbs{font-size:.82rem;padding:.75rem 1rem}}';
      document.head.appendChild(style);
    }
    rebuildMenus();
    addBreadcrumbs();
  };

  document.addEventListener('DOMContentLoaded', install, {once:true});
  document.addEventListener('shopify:section:load', install);
  install();
  let queued = false;
  const menuMutationSelector = 'dpet-header-menu, .dpet-menu__links, .dpet-menu__mobile-links';
  new MutationObserver(records => {
    if (queued) return;
    // Chat, cart and carousel changes do not require rebuilding the navigation.
    const menuChanged = records.some(record =>
      (record.target instanceof Element && record.target.closest(menuMutationSelector)) ||
      [...record.addedNodes, ...record.removedNodes].some(node =>
        node instanceof Element && (node.matches(menuMutationSelector) || node.querySelector(menuMutationSelector))
      )
    );
    if (!menuChanged) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      rebuildMenus();
    });
  }).observe(document.documentElement, {childList:true, subtree:true});
})();

/* dPet.mt navigation stability and mobile tap repair — 2026-10-04 */
(() => {
  const STYLE_ID = 'dpet-navigation-stability';
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media (min-width:750px){',
      'dpet-header-menu .dpet-menu__item{position:static!important;}',
      'dpet-header-menu .dpet-menu__panel{top:calc(100% - 1px)!important;animation:none!important;transform:none!important;}',
      'dpet-header-menu .dpet-menu__trigger{transform:none!important;transition:background-color .16s ease,box-shadow .16s ease!important;}',
      'dpet-header-menu .dpet-menu__links a:hover,dpet-header-menu .dpet-menu__links a:focus-visible{transform:none!important;}',
      '}',
      '@media (max-width:749px){',
      '.dpet-menu__drawer-categories,.dpet-menu__drawer-categories details,.dpet-menu__drawer-categories summary,.dpet-menu__drawer-categories a{pointer-events:auto!important;}',
      '.dpet-menu__drawer-categories summary,.dpet-menu__drawer-categories a{touch-action:manipulation!important;}',
      '.dpet-menu__drawer-categories{position:relative!important;z-index:3!important;width:100%!important;}',
      '.dpet-menu__drawer-categories summary{position:relative!important;z-index:4!important;}',
      '.dpet-menu__drawer-categories .dpet-menu__mobile-links{position:relative!important;z-index:5!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  const setupDesktop = (root) => {
    if (!root || root.dataset.dpetStableMenu === 'true') return;
    root.dataset.dpetStableMenu = 'true';

    try { root.events?.abort(); } catch (error) {}
    const controller = new AbortController();
    root.events = controller;
    const { signal } = controller;
    const desktop = window.matchMedia('(min-width:750px)');
    const items = Array.from(root.querySelectorAll('.dpet-menu__item'));
    let closeTimer = 0;
    let activeItem = null;

    const triggerFor = (item) => item?.querySelector('.dpet-menu__trigger');
    const panelFor = (item) => item?.querySelector('.dpet-menu__panel');
    const closeAll = () => {
      window.clearTimeout(closeTimer);
      activeItem = null;
      items.forEach((item) => {
        const trigger = triggerFor(item);
        const panel = panelFor(item);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    };
    const openItem = (item, focusFirstLink = false) => {
      if (!item) return;
      window.clearTimeout(closeTimer);
      if (activeItem === item) {
        if (focusFirstLink) panelFor(item)?.querySelector('a')?.focus();
        return;
      }
      activeItem = item;
      items.forEach((candidate) => {
        const active = candidate === item;
        const trigger = triggerFor(candidate);
        const panel = panelFor(candidate);
        if (trigger) trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
        if (panel) panel.hidden = !active;
      });
      if (focusFirstLink) panelFor(item)?.querySelector('a')?.focus();
    };
    const scheduleClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!root.matches(':hover') && !root.contains(document.activeElement)) closeAll();
      }, 1200);
    };

    root.addEventListener('pointerover', (event) => {
      if (!desktop.matches || event.pointerType === 'touch') return;
      const item = event.target.closest?.('.dpet-menu__item');
      const previousItem = event.relatedTarget?.closest?.('.dpet-menu__item');
      if (!item || !root.contains(item) || item === previousItem) return;
      window.clearTimeout(closeTimer);
      openItem(item);
    }, { signal });

    root.addEventListener('pointerout', (event) => {
      if (!desktop.matches || event.pointerType === 'touch') return;
      const currentItem = event.target.closest?.('.dpet-menu__item');
      const nextItem = event.relatedTarget?.closest?.('.dpet-menu__item');
      if (currentItem === nextItem) return;
      if (nextItem && root.contains(nextItem)) {
        openItem(nextItem);
        return;
      }
      if (!event.relatedTarget || !root.contains(event.relatedTarget)) scheduleClose();
    }, { signal });

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('.dpet-menu__trigger');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openItem(trigger.closest('.dpet-menu__item'));
    }, { capture: true, signal });

    root.addEventListener('keydown', (event) => {
      const trigger = event.target.closest?.('.dpet-menu__trigger');
      if (trigger && event.key === 'ArrowDown') {
        event.preventDefault();
        openItem(trigger.closest('.dpet-menu__item'), true);
        return;
      }
      if (trigger && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
        event.preventDefault();
        const item = trigger.closest('.dpet-menu__item');
        const current = items.indexOf(item);
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const next = items[(current + offset + items.length) % items.length];
        openItem(next);
        triggerFor(next)?.focus();
        return;
      }
      if (event.key === 'Escape') {
        const active = items.find((item) => triggerFor(item)?.getAttribute('aria-expanded') === 'true');
        closeAll();
        if (active) {
          event.preventDefault();
          triggerFor(active)?.focus();
        }
      }
    }, { signal });

    root.addEventListener('focusin', (event) => {
      const item = event.target.closest?.('.dpet-menu__item');
      if (desktop.matches && item && root.contains(item)) openItem(item);
    }, { signal });
    root.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!root.contains(document.activeElement)) scheduleClose();
      }, 0);
    }, { signal });
    document.addEventListener('pointerdown', (event) => {
      if (!root.contains(event.target)) closeAll();
    }, { signal });
    desktop.addEventListener('change', closeAll, { signal });

    root.open = openItem;
    root.close = closeAll;
  };

  const setupAll = () => document.querySelectorAll('dpet-header-menu').forEach(setupDesktop);

  document.addEventListener('click', (event) => {
    const summary = event.target.closest?.('.dpet-menu__drawer-categories summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    const outer = summary.closest('.dpet-menu__drawer-categories > details');
    if (details === outer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const willOpen = !details.open;
    const list = details.parentElement;
    if (list) {
      Array.from(list.children).forEach((child) => {
        if (child !== details && child.tagName === 'DETAILS') child.open = false;
      });
    }
    details.open = willOpen;
    summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }, true);

  document.addEventListener('DOMContentLoaded', setupAll, { once: true });
  document.addEventListener('shopify:section:load', setupAll);
  setupAll();
  new MutationObserver(setupAll).observe(document.documentElement, { childList: true, subtree: true });
})();


/* dPet.mt menu input guard v2 — 2026-10-04 */
(() => {
  if (window.__dpetMenuInputGuardV2) return;
  window.__dpetMenuInputGuardV2 = true;
  const linkSelector = '.dpet-menu__links a[href], .dpet-menu__mobile-links a[href]';
  const protectedSelector = 'dpet-header-menu .dpet-menu__trigger, .dpet-menu__drawer-categories summary';
  const targetFor = (event, selector) => event.target?.closest?.(selector);
  const shield = (event) => {
    if (targetFor(event, protectedSelector)) event.stopPropagation();
  };

  const installDirectLinkNavigation = () => {
    document.querySelectorAll(linkSelector).forEach((link) => {
      if (link.dataset.dpetDirectNav === 'true') return;
      link.dataset.dpetDirectNav = 'true';
      let touchStartX = 0;
      let touchStartY = 0;
      let touchMoved = false;
      link.addEventListener('mouseup', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const href = link.href;
        if (!href || href.startsWith('javascript:')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = href;
      }, true);
      link.addEventListener('touchstart', (event) => {
        const touch = event.touches?.[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchMoved = false;
      }, { capture: true, passive: true });
      link.addEventListener('touchmove', (event) => {
        const touch = event.touches?.[0];
        if (!touch) return;
        if (Math.abs(touch.clientX - touchStartX) > 12 || Math.abs(touch.clientY - touchStartY) > 12) touchMoved = true;
      }, { capture: true, passive: true });
      link.addEventListener('touchend', (event) => {
        if (touchMoved) return;
        const href = link.href;
        if (!href || href.startsWith('javascript:')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = href;
      }, { capture: true, passive: false });
    });
  };
  installDirectLinkNavigation();
  document.addEventListener('DOMContentLoaded', installDirectLinkNavigation, { once: true });
  document.addEventListener('shopify:section:load', installDirectLinkNavigation);
  new MutationObserver(installDirectLinkNavigation).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pointerdown', shield, true);
  window.addEventListener('mousedown', shield, true);
  window.addEventListener('touchstart', shield, { capture: true, passive: true });
  let pressedLink = null;
  let pressX = 0;
  let pressY = 0;
  let pressMoved = false;
  window.addEventListener('pointerdown', (event) => {
    const link = targetFor(event, linkSelector);
    if (!link) return;
    pressedLink = link;
    pressX = event.clientX;
    pressY = event.clientY;
    pressMoved = false;
  }, true);
  window.addEventListener('pointermove', (event) => {
    if (!pressedLink) return;
    if (Math.abs(event.clientX - pressX) > 12 || Math.abs(event.clientY - pressY) > 12) pressMoved = true;
  }, true);
  window.addEventListener('pointerup', (event) => {
    const link = targetFor(event, linkSelector);
    const shouldFollow = pressedLink && link === pressedLink && !pressMoved;
    pressedLink = null;
    if (!shouldFollow) return;
    const href = link.href;
    if (!href || href.startsWith('javascript:')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(href);
  }, true);
  window.addEventListener('pointercancel', () => { pressedLink = null; }, true);
  window.addEventListener('click', (event) => {
    const link = targetFor(event, linkSelector);
    if (link) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const href = link.href;
      if (!href || href.startsWith('javascript:')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(href);
      return;
    }
    const trigger = targetFor(event, 'dpet-header-menu .dpet-menu__trigger');
    if (trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const host = trigger.closest('dpet-header-menu');
      const item = trigger.closest('.dpet-menu__item');
      if (host?.open) host.open(item);
      else {
        host?.querySelectorAll('.dpet-menu__item').forEach((candidate) => {
          const active = candidate === item;
          candidate.querySelector('.dpet-menu__trigger')?.setAttribute('aria-expanded', active ? 'true' : 'false');
          const panel = candidate.querySelector('.dpet-menu__panel');
          if (panel) panel.hidden = !active;
        });
      }
      return;
    }
    const summary = targetFor(event, '.dpet-menu__drawer-categories summary');
    if (!summary) return;
    const details = summary.parentElement;
    const outer = summary.closest('.dpet-menu__drawer-categories > details');
    if (!details || details.tagName !== 'DETAILS' || details === outer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const willOpen = !details.open;
    Array.from(details.parentElement?.children || []).forEach((sibling) => {
      if (sibling !== details && sibling.tagName === 'DETAILS') sibling.open = false;
    });
    details.open = willOpen;
    summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }, true);
})();

/* Keep dRewards above the AI chat button or its expanded panel. */
(() => {
  const root = document.documentElement;
  const watched = new WeakSet();
  const measured = new WeakSet();
  let chat;
  let frame = 0;
  let followUntil = 0;
  let lastBottom = '';
  const queue = () => { if (!frame) frame = requestAnimationFrame(sync); };
  const follow = () => { followUntil = performance.now() + 450; queue(); };
  const sizes = new ResizeObserver(queue);
  const watch = shadow => {
    if (!shadow || watched.has(shadow)) return;
    watched.add(shadow);
    new MutationObserver(queue).observe(shadow, {childList:true, subtree:true});
    shadow.addEventListener('transitionend', queue);
    shadow.addEventListener('animationend', queue);
  };
  const bind = host => {
    if (!host || chat === host) return;
    chat = host;
    new MutationObserver(follow).observe(chat, {attributes:true, attributeFilter:['open','mode','view']});
    queue();
  };
  function sync() {
    frame = 0;
    if (!chat?.isConnected) bind(document.querySelector('shopify-chat'));
    let bottom = 16;
    if (chat?.isConnected) {
      watch(chat.shadowRoot);
      const runtime = chat.shadowRoot?.querySelector('shopify-agent-runtime');
      watch(runtime?.shadowRoot);
      const panel = runtime?.shadowRoot?.querySelector('[part~="dialog"]');
      const activator = runtime?.shadowRoot?.querySelector('[part~="activator"]');
      [panel, activator].forEach(element => {
        if (element && !measured.has(element)) { measured.add(element); sizes.observe(element); }
      });
      const target = chat.hasAttribute('open') ? panel : activator;
      const rect = target?.getBoundingClientRect();
      bottom = rect?.height > 0 ? Math.max(16, window.innerHeight - rect.top + 12) : 88;
      bottom = Math.min(bottom, Math.max(16, window.innerHeight - 68));
    }
    const value = Math.round(bottom) + 'px';
    if (value !== lastBottom) { root.style.setProperty('--dpet-rewards-bottom', value); lastBottom = value; }
    if (performance.now() < followUntil) queue();
  }
  const start = () => {
    bind(document.querySelector('shopify-chat'));
    new MutationObserver(records => {
      if (chat?.isConnected) return;
      for (const record of records) for (const node of record.addedNodes) {
        if (node instanceof Element) bind(node.matches('shopify-chat') ? node : node.querySelector('shopify-chat'));
      }
    }).observe(document.body, {childList:true, subtree:true});
    customElements.whenDefined('shopify-chat').then(queue);
    customElements.whenDefined('shopify-agent-runtime').then(queue);
    window.addEventListener('resize', queue, {passive:true});
    window.visualViewport?.addEventListener('resize', queue, {passive:true});
    window.visualViewport?.addEventListener('scroll', queue, {passive:true});
    queue();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

/* dPet quick-view overlay — keep separate from sale labels. */
(() => {
  const installDpetQuickViewStyles = () => {
    if (document.getElementById("dpet-quick-view-styles")) return;
    const style = document.createElement("style");
    style.id = "dpet-quick-view-styles";
    style.textContent = `
      product-card:has(.dpet-quick-view) { position: relative; }
      product-card .dpet-quick-view {
        position: absolute; inset-block-end: 12px; inset-inline-end: 12px; z-index: 12;
        display: grid; place-items: center; width: 42px; height: 42px; padding: 0;
        border: 1px solid #ef6b2e; border-radius: 50%; background: #fff; color: #ef6b2e;
        box-shadow: 0 3px 12px rgba(23, 42, 34, .14); cursor: pointer;
        opacity: 0; transform: translateY(-3px); pointer-events: none;
        transition: opacity .18s ease, transform .18s ease, background-color .18s ease, color .18s ease;
      }
      product-card .dpet-quick-view svg { width: 19px; height: 19px; fill: none; stroke: currentColor; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
      product-card:hover .dpet-quick-view, product-card:focus-within .dpet-quick-view { opacity: 1; transform: translateY(0); pointer-events: auto; }
      product-card .dpet-quick-view:hover, product-card .dpet-quick-view:focus-visible { background: #ef6b2e; color: #fff; outline: 2px solid #fff; outline-offset: 2px; }
      @media (hover: none), (max-width: 749px) {
        product-card .dpet-quick-view { opacity: 1; transform: none; pointer-events: auto; width: 38px; height: 38px; inset-block-end: 9px; inset-inline-end: 9px; }
      }
      @media (prefers-reduced-motion: reduce) { product-card .dpet-quick-view { transition: none; } }
    `;
    document.head.append(style);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", installDpetQuickViewStyles, { once: true });
  else installDpetQuickViewStyles();
})();
